import { getMediaImageUrl } from '../../../utils/img';

export const getImageUrlWithFallback = (customContent, currentLanguage) => {
  const media =
    customContent[currentLanguage] ||
    customContent['zh-hant'] ||
    customContent['en'] ||
    Object.values(customContent).find((content) => content?.images?.original);

  if (!media?.images?.original) {
    return null;
  }

  const { width, height } = media.images.original;
  const size = `${Math.round(width)}x${Math.round(height)}`;

  return getMediaImageUrl(media, { size });
};

export const getContentWithFallback = (customContent, currentLanguage) => {
  const isValidContent = (content) => content?.title || content?.content;

  if (isValidContent(customContent[currentLanguage])) {
    return customContent[currentLanguage];
  }

  if (isValidContent(customContent['zh-hant'])) {
    return customContent['zh-hant'];
  }

  if (isValidContent(customContent['en'])) {
    return customContent['en'];
  }

  const firstValidLang = Object.values(customContent).find(isValidContent);

  return firstValidLang || null;
};
